// import AddProject from "../containers/sidebar-icons/Add Projects.svg";
import AddVendors from "../containers/sidebar-icons/Add Vendors.svg";
// import CategoryMaster from "../containers/sidebar-icons/Category Master.svg";
// import CategoryOpportunity from "../containers/sidebar-icons/Category Opportunity.svg";
import OpportunityDashboard from "../containers/sidebar-icons/Opportunity Dashboard.svg";
import OpportunityList from "../containers/sidebar-icons/Category.svg";
// import Overview from "../containers/sidebar-icons/Overview.svg";
// import ParentNames from "../containers/sidebar-icons/Parent Names.svg";
// import ProjectStatus from "../containers/sidebar-icons/Project Status.svg";
import Projects from "../containers/sidebar-icons/Projects.svg";
import SpendDashboard from "../containers/sidebar-icons/Spend Dashboard.svg";
import SpendDataUpload from "../containers/sidebar-icons/Spend Data Upload.svg";
import UserManagement from "../containers/sidebar-icons/User Management.svg";
import Vendors from "../containers/sidebar-icons/Vendors.svg";
import Summary from "../containers/sidebar-icons/Summary.svg";
import Category from "../containers/sidebar-icons/Category.svg";
// import AchievementDashboard from "../containers/sidebar-icons/Achievement Dashboard.svg";

const UserType = {
    SysAdmin: 0,
    GroupAdmin: 1,
    ClientAdmin: 2,
    ClientUser: 3
}

const common = (userType) => [
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Overview",
    //     to: "/overview",
    //     icon: {
    //         slot: "img",
    //         src: Overview,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    {
        _name: "CSidebarNavTitle",
        _children: ["Dashboard"]
    },
    {
        _name: "CSidebarNavItem",
        name: "Summary Dashboard",
        to: "/summary-dashboard",
        icon: {
            slot: "img",
            src: Summary,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Spend Dashboard",
        to: "/spend-dashboard",
        _attrs: { class: 'c-sidebar-nav-item c-sidebar-nav-subitem' },
        icon: {
            slot: "img",
            src: SpendDashboard,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Supply Spend",
        to: "/supply-spend",
        _attrs: { class: 'c-sidebar-nav-item c-sidebar-nav-subitem' },
        icon: {
            slot: "img",
            src: Category,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Service Spend",
        to: "/service-spend",
        _attrs: { class: 'c-sidebar-nav-item c-sidebar-nav-subitem' },
        icon: {
            slot: "img",
            src: Category,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Opportunity Dashboard",
        to: "/opportunity-dashboard",
        icon: {
            slot: "img",
            src: OpportunityDashboard,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Opportunity List",
        to: "/opportunity-list",
        _attrs: { class: 'c-sidebar-nav-item c-sidebar-nav-subitem' },
        icon: {
            slot: "img",
            src: OpportunityList,
            class: "c-sidebar-nav-icon"
        }
    },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Achievement Dashboard",
    //     to: "/achievement-dashboard",
    //     icon: {
    //         slot: "img",
    //         src: AchievementDashboard,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    ...userType === UserType.SysAdmin ? [{
        _name: "CSidebarNavTitle",
        _children: ["Opportunity"]
    },
    {
        _name: "CSidebarNavItem",
        name: "Opportunity Identification",
        to: "/opportunity-identification",
        icon: {
            slot: "img",
            src: Projects,
            class: "c-sidebar-nav-icon"
        }
    },
    {
        _name: "CSidebarNavItem",
        name: "Opportunity Categories",
        to: "/opportunity-categories",
        icon: {
            slot: "img",
            src: Projects,
            class: "c-sidebar-nav-icon"
        }
    }] : [],
    // {
    //     _name: "CSidebarNavTitle",
    //     _children: ["Projects"]
    // },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Projects",
    //     to: "/projects",
    //     icon: {
    //         slot: "img",
    //         src: Projects,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Add Project",
    //     to: "/projects/new",
    //     icon: {
    //         slot: "img",
    //         src: AddProject,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    // {
    //     _name: "CSidebarNavTitle",
    //     _children: ["Categories"]
    // },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Category Opportunity",
    //     to: "/categories-opportunities",
    //     icon: {
    //         slot: "img",
    //         src: CategoryOpportunity,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Category Master",
    //     to: "/categories-master",
    //     icon: {
    //         slot: "img",
    //         src: CategoryMaster,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    {
        _name: "CSidebarNavTitle",
        _children: ["Vendors"]
    },
    {
        _name: "CSidebarNavItem",
        name: "Vendors",
        to: "/vendors",
        icon: {
            slot: "img",
            src: Vendors,
            class: "c-sidebar-nav-icon"
        }
    },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Add Vendor",
    //     to: "/vendors/new",
    //     icon: {
    //         slot: "img",
    //         src: AddVendors,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    // {
    //     _name: "CSidebarNavItem",
    //     name: "Parent Names",
    //     to: "/parent-names",
    //     icon: {
    //         slot: "img",
    //         src: ParentNames,
    //         class: "c-sidebar-nav-icon"
    //     }
    // },
    ...userType === UserType.SysAdmin ? [
        {
            _name: "CSidebarNavTitle",
            _children: ["Data Upload"]
        },
        {
            _name: "CSidebarNavItem",
            name: "Spend Data Upload",
            to: "/approve-spend",
            icon: {
                slot: "img",
                src: SpendDataUpload,
                class: "c-sidebar-nav-icon"
            }
        }] : []
];

export const client_admin = [
    {
        _name: "CSidebarNav",
        _children: [
            ...common(UserType.ClientAdmin),
            {
                _name: "CSidebarNavTitle",
                _children: ["Admin"]
            },
            {
                _name: "CSidebarNavItem",
                name: "User Management",
                to: "/user-management",
                icon: {
                    slot: "img",
                    src: UserManagement,
                    class: "c-sidebar-nav-icon"
                }
            },
            {
                _name: "CSidebarNavItem",
                name: "File Upload Status",
                to: "/file-import-status",
                icon: "cil-cloud-upload"
            }
        ]
    }
];

export const client_user = [
    {
        _name: "CSidebarNav",
        _children: [...common(UserType.ClientUser)]
    }
];

// export const sys_admin = [
//     {
//         _name: "CSidebarNav",
//         _children: [
//             ...common,
//             {
//                 _name: "CSidebarNavTitle",
//                 _children: ["Admin"]
//             },
//             {
//                 _name: "CSidebarNavItem",
//                 name: "Client Management",
//                 to: "/client-management",
//                 icon: {
//                     slot: "img",
//                     src: UserManagement,
//                     class: "c-sidebar-nav-icon"
//                 }
//             },
//             {
//                 _name: "CSidebarNavItem",
//                 name: "File Upload Status",
//                 to: "/file-import-status",
//                 icon: "cil-cloud-upload"
//             }
//         ]
//     }
// ];

const sysAdmin = [
    {
        _name: "CSidebarNav",
        _children: [
            ...common(UserType.SysAdmin),
            {
                _name: "CSidebarNavTitle",
                _children: ["Admin"]
            },
            {
                _name: "CSidebarNavItem",
                name: "Client Management",
                to: "/client-management",
                icon: {
                    slot: "img",
                    src: UserManagement,
                    class: "c-sidebar-nav-icon"
                }
            },
            {
                _name: "CSidebarNavItem",
                name: "File Upload Status",
                to: "/file-import-status",
                icon: "cil-cloud-upload"
            }
        ]
    }
];

// sysAdmin[0]._children.splice(
//     sysAdmin[0]._children.findIndex(item => item.to === "/projects/new") + 1,
//     0,
//     {
//         _name: "CSidebarNavItem",
//         name: "Project Status",
//         to: "/projects/status",
//         icon: {
//             slot: "img",
//             src: ProjectStatus,
//             class: "c-sidebar-nav-icon"
//         }
//     }
// );

export const sys_admin = sysAdmin;

const groupAdmin = [
    {
        _name: "CSidebarNav",
        _children: [
            ...common(UserType.GroupAdmin),
            {
                _name: "CSidebarNavTitle",
                _children: ["Admin"]
            },
            {
                _name: "CSidebarNavItem",
                name: "Client Management",
                to: "/client-management",
                icon: {
                    slot: "img",
                    src: UserManagement,
                    class: "c-sidebar-nav-icon"
                }
            },
            {
                _name: "CSidebarNavItem",
                name: "File Upload Status",
                to: "/file-import-status",
                icon: "cil-cloud-upload"
            }
        ]
    }
];

export const group_admin = groupAdmin;
